<template>
  <!-- Matches a default-density input's control height so icon buttons centre on the input
       itself rather than on the input plus its reserved error-message area. -->
  <div class="row-actions">
    <slot />
  </div>
</template>

<style scoped>
.row-actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  height: 56px;
}
</style>
